export const dedicatedPortfoliosLabels = {
  scoringTool: 'ESG Scoring Tool',
};
